import React from "react";
import { StripeAdvertisementComp } from './StripeAdvertisementComp';
import './StripeAdvertisement.scss'

interface Props {
  handleHistory: (url?: string) => void;
}

export const StripeAdvertisement: React.FC<Props> = (props) => <StripeAdvertisementComp {...props} />;